import PropTypes from 'prop-types';
import useUser from '@/hooks/api/useUser';
import useCheckLocalStorage from '@/hooks/browser/useCheckLocalStorage';
import Portal from '@/components/app/Portal';
import { classes } from '@/helpers/styling';
import useAppFilter from '@/hooks/layout/useAppFilter';

const PageHeader = ({ children, hideContent }) => {
  const { failedLogin } = useUser();
  const { appIsFiltered } = useAppFilter();
  const { showCookieError } = useCheckLocalStorage();

  const showHeaderContent = !hideContent && !failedLogin && !showCookieError;
    
  return (
    <Portal selectorId='custom-page-header'>
      <div className={ classes('page-header', { '--is-filtered': appIsFiltered }) }>
        { showHeaderContent ? children : null }
      </div>
    </Portal>
  );
};

PageHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  hideContent: PropTypes.bool
};

PageHeader.defaultProps = { hideContent: false };

export default PageHeader;